import { SET_ERROR_LOG_PARAMETER } from "./ComponentErrorLogType";


const initialState = {
    errorLogParam: {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ERROR_LOG_PARAMETER:
            return {                
                ...state, errorLogParam : action.value
            }     
        default:
            return state;
    }
};

export default reducer;
